import React, { ReactNode } from 'react'
import styled from '@emotion/styled'

interface PortalEditorFieldProps {
  label: string
  helper?: string
  children: ReactNode
}

export function PortalEditorField({ label, helper, children }: PortalEditorFieldProps) {
  return (
    <FieldLayout>
      <FieldLabel>{label}</FieldLabel>
      {children}
      {helper ? <FieldHelper>{helper}</FieldHelper> : null}
    </FieldLayout>
  )
}

const FieldLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`

const FieldLabel = styled.span`
  color: #5f6f82;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
`

const FieldHelper = styled.span`
  color: #8fa0b5;
  font-size: 12px;
  line-height: 1.35;
`
